import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { IBreadcrumb } from './breadcrumb.interface';
import { ITabs } from '@shared/model/project';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent {
  @Input() tabs!: ITabs | null;
  @Input() breadcrumbs!: IBreadcrumb[];

  baseUrl: string = 'project';

  isRender(name: string): boolean {
    if (this.tabs) {
      switch (name) {
        case 'modeling-working-capital':
          return this.tabs?.working_capital_tab;
        case 'modeling-of-equity-contributions':
          return this.tabs?.own_capitals_tab;
        case 'loan-modeling':
          return this.tabs?.credits_tab;
        case 'leasing-modeling':
          return this.tabs?.leasings_tab;
        case 'capital-investments':
          return this.tabs?.capexs_tab;
        case 'sources-of-funding':
          return (
            this.tabs?.working_capital_tab ||
            this.tabs?.own_capitals_tab ||
            this.tabs?.credits_tab ||
            this.tabs?.leasings_tab ||
            this.tabs?.capexs_tab
          );
        default:
          return true;
      }
    } else {
      return true;
    }
  }
}
